const LOGO_URL = "https://customer-assets.emergentagent.com/job_glow-menu-pro/artifacts/t52taumm_360RGE%20-%20Final-Logo%204A-Color-Icon%20Landsacape-TM%20copy%203.png";

/**
 * Small "Part of 360RGE" attribution badge with the customer logo.
 * Variants:
 *  - "pill"   – glassmorphic rounded pill (good for headers)
 *  - "inline" – minimal label + logo (good for footers / auth pages)
 *  - "stack"  – vertical with label on top (good for sidebars)
 */
export default function Powered360({ variant = "pill", className = "" }) {
    if (variant === "stack") {
        return (
            <div className={`flex flex-col items-start gap-1.5 ${className}`} data-testid="powered-360rge">
                <span className="text-[9px] font-mono uppercase tracking-[0.22em] text-zinc-500">Part of</span>
                <a href="https://360rge.com" target="_blank" rel="noopener noreferrer" className="block">
                    <img src={LOGO_URL} alt="360RGE — 360 Restaurant Growth Engine" className="h-6 w-auto opacity-90 hover:opacity-100 transition" />
                </a>
            </div>
        );
    }
    if (variant === "inline") {
        return (
            <a
                href="https://360rge.com"
                target="_blank"
                rel="noopener noreferrer"
                className={`inline-flex items-center gap-2 group ${className}`}
                data-testid="powered-360rge"
            >
                <span className="text-[10px] font-mono uppercase tracking-[0.22em] text-zinc-500">Part of</span>
                <img src={LOGO_URL} alt="360RGE — 360 Restaurant Growth Engine" className="h-5 w-auto opacity-85 group-hover:opacity-100 transition" />
            </a>
        );
    }
    // pill (default)
    return (
        <a
            href="https://360rge.com"
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-flex items-center gap-2.5 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 hover:bg-white/8 hover:border-white/15 transition ${className}`}
            data-testid="powered-360rge"
        >
            <span className="text-[10px] font-mono uppercase tracking-[0.22em] text-zinc-400">Part of</span>
            <img src={LOGO_URL} alt="360RGE — 360 Restaurant Growth Engine" className="h-4 w-auto" />
        </a>
    );
}
